import { useBatchSync } from './useBatchSync'
import { useGetByEngagementId } from './useGetByEngagementId'

export type { BatchLogEntry, WorkflowEventType, WorkflowLogMetadata } from './useBatchSync'
export type { WorkflowLogApiEvent, WorkflowLogOperator, WorkflowLogResponse } from './useGetByEngagementId'

export const workflowLogs = {
  batchSync: useBatchSync,
  getByEngagementId: useGetByEngagementId,
}
